<table
  *ngIf="layout === 'table'; else listView"
  mat-table
  matSort
  matSortActive="triggerDate"
  matSortDirection="desc"
  fxFlex
  recycleRows
  [dataSource]="dataSource"
  [trackBy]="trackByData"
>
  <ng-container matColumnDef="icon">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let data" mat-cell>
      <pr-automation-icon [automation]="data.automation.data" />
    </td>
  </ng-container>

  <ng-container matColumnDef="select">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let data" mat-cell>
      <div
        *ngIf="multiSelect"
        class="checkbox"
        (click)="$event.stopPropagation()"
      >
        <mat-checkbox
          color="primary"
          [checked]="data.isSelected"
          (change)="toggle($event, data.automation)"
        />
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
    <td *matCellDef="let data" mat-cell>
      <pr-automation-status
        [status]="data.automation.status"
        [errorMessage]="data.automation.errorMessage"
      />
    </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Type</th>
    <td *matCellDef="let data" mat-cell>
      {{ data.automation.type | map: getTypeLabel }}
    </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th *matHeaderCellDef mat-header-cell>Title</th>
    <td *matCellDef="let data" mat-cell>
      <pr-content-text [content]="data.automation | map: getTitle" />
    </td>
  </ng-container>

  <ng-container matColumnDef="patient">
    <th *matHeaderCellDef mat-header-cell>Patient</th>
    <td *matCellDef="let data" mat-cell>
      <ng-container *ngIf="data.automation.patientMention">
        <pr-content-view [content]="data.automation.patientMention" />
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="appointment">
    <th *matHeaderCellDef mat-header-cell>Appointment</th>
    <td *matCellDef="let data" mat-cell>
      <span *ngIf="data.automation.appointmentSummary">
        {{ data.automation.appointmentSummary }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="createdBy">
    <th *matHeaderCellDef mat-header-cell>Created By</th>
    <td *matCellDef="let data" mat-cell class="created-by">
      <div class="flex min-w-0 items-center gap-2">
        <mat-icon
          class="icon-sm shrink-0 opacity-50"
          [matTooltip]="data.automation.creator.type | map: getCreatorLabel"
          >{{ data.automation.creator.type | map: getCreatorIcon }}</mat-icon
        >
        @if (data.campaignEntry) {
          <a
            [prBrandRouterLink]="[
              'campaigns',
              data.campaignEntry.campaignId,
              'entries',
              data.campaignEntry.id
            ]"
          >
            {{ data.automation.creator.name }}
          </a>
        } @else {
          <span class="overflow-hidden text-ellipsis">{{
            data.automation.creator.name
          }}</span>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Created At</th>
    <td *matCellDef="let data" mat-cell>
      {{ data.automation.createdAt | moment | amDateFormat: dateFormat }}
    </td>
  </ng-container>

  <ng-container matColumnDef="triggerDate">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Trigger Date</th>
    <td *matCellDef="let data" mat-cell>
      <span *ngIf="data.automation.triggerDate; else noDate">
        <ng-container
          *ngIf="
            data.automation.triggerDate
              | momentTimezone$: data.automation.practiceRef
              | ngrxPush as triggerDate
          "
        >
          {{ triggerDate | amDateFormat: dateFormat }}
        </ng-container>
      </span>
      <ng-template #noDate>No Trigger Date</ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="more">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let data" mat-cell>
      <pr-automation-list-item-menu
        [automation]="data.automation"
        (editAutomation)="editAutomation.next($event)"
        (cancelAutomation)="cancelAutomation.next($event)"
        (restoreAutomation)="restoreAutomation.next($event)"
        (resendAutomation)="resendAutomation.next($event)"
        (previewAutomation)="previewAutomation.next($event)"
      />
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
</table>

<ng-template #listView>
  <ng-container *ngIf="listData$ | async as listData">
    <div
      *ngIf="listData.length; else noAutomations"
      class="flex flex-col gap-2"
    >
      <pr-automation-list-item
        *ngFor="let data of listData; trackBy: trackByData"
        [automation]="data.automation"
        [withCheckbox]="multiSelect"
        [checked]="data.isSelected"
        [newDate]="data.newDate"
        (checkedChange)="toggle($event, data.automation)"
      >
        <pr-automation-list-item-menu
          [automation]="data.automation"
          (editAutomation)="editAutomation.next($event)"
          (cancelAutomation)="cancelAutomation.next($event)"
          (restoreAutomation)="restoreAutomation.next($event)"
          (resendAutomation)="resendAutomation.next($event)"
          (previewAutomation)="previewAutomation.next($event)"
        />
      </pr-automation-list-item>
    </div>
    <ng-template #noAutomations>
      <div fxLayoutAlign="center stretch">
        <small class="layout-margin">No Automations</small>
      </div>
    </ng-template>
  </ng-container>
</ng-template>
